import { GlobeIcon, LocationIcon, UsersIcon, SearchIcon } from '../Brand/Icon';
import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import { setLocalStorage, getLocalStorage, getUser } from '../../utils/func';
import { useLocation, useNavigate } from 'react-router-dom';
import config from '../../utils/config';
import { APP_ROUTES } from '../../utils/constant';
import url from '../../utils/url';
import { useTranslation } from 'react-i18next';
import './index.scss';

const PostFilter = ({ onSearch, searchDisabled = false, filtersDisabled = searchDisabled }) => {
  const { t } = useTranslation();
  const [area, setArea] = useState(() => {
    const saved = getLocalStorage(config.area);
    return !saved || saved === 'null' ? config.areaType.all : saved;
  });
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let saved = getLocalStorage(config.area);
    if (saved === null || saved === 'null') {
      saved = config.areaType.all;
      setLocalStorage(config.area, saved);
    }
    setArea(saved);
  }, []);

  const changeArea = (nextArea) => {
    if (nextArea === config.areaType.friends && !getUser()) {
      navigate(`${url(APP_ROUTES.LOGIN)}?from=${encodeURIComponent(url(APP_ROUTES.MAIN))}`);
      return;
    }
    if (nextArea === area) return;
    setLocalStorage(config.area, nextArea);
    setArea(nextArea);
    // Refresh just the feed. Reloading the document flashes the startup screen
    // and tears down the app (including open navigation and cached assets).
    navigate(url(APP_ROUTES.MAIN), { state: { feedRefresh: `${Date.now()}-${nextArea}` } });
  };

  const openSearch = () => {
    if (onSearch) { onSearch(); return; }
    navigate(url(APP_ROUTES.SEARCH), { state: {
      searchOrigin: { pathname: location.pathname, search: location.search, state: location.state },
      fromSearchEntry: true,
    } });
  };

  return <div className="wiwHeader post-filter">
    <div className="post-filter-row">
      <Button aria-label={t('brand:searchTitle')} onClick={openSearch} disabled={searchDisabled} icon={<SearchIcon />} />
      <Button aria-label={t('post.filter_all')} aria-pressed={area === config.areaType.all}
        disabled={filtersDisabled}
        onClick={() => changeArea(config.areaType.all)} className={area === config.areaType.all ? 'active-btn' : ''} icon={<GlobeIcon />} />
      <Button aria-label={t('post.filter_local')} aria-pressed={area === config.areaType.country}
        disabled={filtersDisabled}
        onClick={() => changeArea(config.areaType.country)} className={area === config.areaType.country ? 'active-btn' : ''} icon={<LocationIcon />} />
      <Button aria-label={t('post.filter_friends')} aria-pressed={area === config.areaType.friends}
        disabled={filtersDisabled}
        onClick={() => changeArea(config.areaType.friends)} className={area === config.areaType.friends ? 'active-btn' : ''} icon={<UsersIcon />} />
    </div>
  </div>;
};

export default PostFilter;
